import password_show from "../../assets/images/icon_show_password.svg";
import password_hide from "../../assets/images/icon_hide_password.svg";
import { Input } from "antd";

const CustomInput = ({ label, value, type = "text", onChange, disabled = false, handleShow, showPassword, errorMessage, ...rest }) => {
    return (
        <div className="form_group">
            <label>{label}</label>
            {
                type !== "password" ? (
                    <Input
                        {...rest}
                        value={value}
                        className="form_control"
                        onChange={onChange}
                        type={type}
                        autoComplete={"off"}
                        disabled={disabled}
                    />
                ) : (
                    <div className="position_relative fullWidth">
                        <span className="show_password">
                            <img
                                onClick={() => handleShow(rest.name)}
                                src={`${showPassword[rest.name] ? password_show : password_hide}`}
                                alt="Show password"
                            />
                        </span>
                        <input
                            {...rest}
                            autoComplete={"off"}
                            value={value}
                            onChange={onChange}
                            type={`${showPassword[rest.name] ? "text" : type}`}
                            className="form_control"
                        />
                        <p>{errorMessage}</p>
                    </div>
                )
            }
            {errorMessage && type !== "password" &&  <p className="errormsg">{errorMessage}</p>} 
        </div>
    )
};

export default CustomInput;